import React, { useState } from 'react';
import Footer from './Footer';
import CanonicalTag from './CanonicalTag';
import { Helmet } from 'react-helmet';
import "../index.css";
import defaultImage from '../assets/Images/factory.jpg';
import hoverImage from '../assets/Images/mill.jpg';
import factory from '../assets/Images/factory-1.jpg';

const About = () => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <>
      
      <Helmet>
        <title>About |Cement machinery parts | Valerion Impex Pvt Ltd</title>
        <meta
          name="description"
          content="Valerion Impex Pvt Ltd is a trusted manufacturer and distributor of complex machined parts for the cement and railroad industries."
        />
      </Helmet>
       <CanonicalTag url="https://www.cementmachineryparts.in/about"/>

      <div className="container mt-2 about-sec">
        <div className="row align-items-center">

          <div className="col-md-6 text-center mb-2">
            <img
              src={isHovered ? hoverImage : defaultImage}
              alt="Factory machinery"
              className="img-fluid circle-img"
              onMouseEnter={() => setIsHovered(true)}
              onMouseLeave={() => setIsHovered(false)}
              style={{ transition: '0.3s ease' }}
            />
          </div>

          <div className="col-md-6 mt-1 mb-5">
            <h1 className="text-center"><b>About Us</b></h1>
            <p>In today’s fast-paced world, having the right part can mean the difference between “on-time” and “off-line.”</p>
            <p>You can rely on Valerion Impex Pvt Ltd to consistently deliver the complex machined parts you need to keep operations humming in the railroad industries.</p>
            <p>Our reputation in the industry is unparalleled and is a direct reflection of our dedication to providing quality products at competitive prices.</p>
            <p>Combine this with our commitment to integrity at every level of our business and you have the obvious solution to all your part manufacturing and distribution needs.</p>
            <p>At Valerion, you will find one of the widest inventories of machined parts available in the industry.</p>
            <p>Our extensive inventory guarantees you a fast turn-around on orders and lower shipping costs as you can consolidate purchasing and delivery from a single supplier.</p>
            <p>Valerion Impex is unique in the industry as we are not just a distributor – we subcontract our manufacturing to qualified machine shops worldwide.</p>
            <p>This allows us to offer our customers many parts that are not available competitively elsewhere. We also can expedite delivery when required.</p>
          </div>

          <div className="col-md-6 text-start py-1">
            <h2 className="mission-heading mb-3 text-center text-primary fs-1"><b>Our Mission</b></h2>
            <div className="d-flex align-items-center justify-content-center">
              <span className="mission-arrow">⇉</span>
              <p className="mission-text">
                “To be the company that provides the<br />
                best services and<br />
                To satisfy our customers globally.”
              </p>
            </div>
          </div>

          <div className="col-md-6 about-fac mb-2">
            <img
              src={factory}
              className="img-fluid rounded"
              style={{ maxHeight: '350px', width: '100%' }}
              alt="Factory image of Valerion Impex Pvt Ltd"
            />
          </div>

        </div>
      </div>
    </>
  );
};

export default About;
